export default {
  getSubscription: (state) => state.subscription,
  getPlans: (state) => state.plans,
};
